/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

export const validateEmail = (email) => {
    var regex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line no-useless-escape
    return email && regex.test(email)
}

export const validateRosterEmail = (email) => {
    var regex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line no-useless-escape

    if (!regex.test(email) && email.length > 0) {
        return "Must be a valid email address"
    } else {
        return false
    }
}

export const validateLength = (val, len) => {
    return val && val.length >= len
}

export const validateName = (name) => {
    if (!validateLength(name, 3)) {
        return "Name must be at least 3 characters"
    } else {
        return false
    }
}

export const validateJerseyNumber = (number) => {
    if (!inRange(number, 0, 999)) {
        return "Jersey number must be between 0 and 999"
    } else {
        return false
    }
}

const inRange = (x, min, max) => {
    return x >= min && x <= max
}
